const actions = {
  LOAD_DASHBOARD_DATA: 'LOAD_DASHBOARD_DATA',
  LOADING_DASHBOARD_DATA: 'LOADING_DASHBOARD_DATA',
  LOADED_DASHBOARD_DATA: 'LOADED_DASHBOARD_DATA',
  LOAD_DASHBOARD_ERROR: 'LOAD_DASHBOARD_ERROR',
  RESET_DASHBOARD_DATA: 'RESET_DASHBOARD_DATA',
  GET_USER_SETTINGS: 'GET_USER_SETTINGS',
  GETTING_USER_SETTINGS: 'GETTING_USER_SETTINGS',
  GOT_USER_SETTINGS: 'GOT_USER_SETTINGS',
  ERROR_USER_SETTINGS: 'ERROR_USER_SETTINGS',
  UPDATE_VAT_AGGREE: 'UPDATE_VAT_AGGREE',
  UPDATED_VAT_AGGREE: 'UPDATED_VAT_AGGREE',
  UPDATING_VAT_AGGREE: 'UPDATING_VAT_AGGREE',
  ERROR_VAT_AGGREE: 'ERROR_VAT_AGGREE',
  FETCH_PAYMENT_COUNT: 'FETCH_PAYMENT_COUNT',
  FETCHING_PAYMENT_COUNT: 'FETCHING_PAYMENT_COUNT',
  FETCHING_PAYMENT_COUNT_FAILED: 'FETCHING_PAYMENT_COUNT_FAILED',
  FETCHED_PAYMENT_COUNT: 'FETCHED_PAYMENT_COUNT',
  RESET_FETCHED_PAYMENT_COUNT: 'RESET_FETCHED_PAYMENT_COUNT',

  FETCH_ACCOUNT_NOTIFICATION: 'FETCH_ACCOUNT_NOTIFICATION',
  LOADING_MORE_ACCOUNT_NOTIFICATION: 'LOADING_MORE_ACCOUNT_NOTIFICATION',
  FETCHING_ACCOUNT_NOTIFICATION: 'FETCHING_ACCOUNT_NOTIFICATION',
  FETCH_ACCOUNT_NOTIFICATION_SUCCESS: 'FETCH_ACCOUNT_NOTIFICATION_SUCCESS',
  FETCH_ACCOUNT_NOTIFICATION_FAILED: 'FETCH_ACCOUNT_NOTIFICATION_FAILED',
  PUSH_ACCOUNT_NOTIFICATION: 'PUSH_ACCOUNT_NOTIFICATION',
  RESET_ACCOUNT_NOTIFICATION: 'RESET_ACCOUNT_NOTIFICATION',

  FETCH_ACCOUNT_SYSTEM_LOGS: 'FETCH_ACCOUNT_SYSTEM_LOGS',
  LOADING_MORE_ACCOUNT_SYSTEM_LOGS: 'LOADING_MORE_ACCOUNT_SYSTEM_LOGS',
  FETCHING_ACCOUNT_SYSTEM_LOGS: 'FETCHING_ACCOUNT_SYSTEM_LOGS',
  FETCH_ACCOUNT_SYSTEM_LOGS_SUCCESS: 'FETCH_ACCOUNT_SYSTEM_LOGS_SUCCESS',
  FETCH_ACCOUNT_SYSTEM_LOGS_FAILED: 'FETCH_ACCOUNT_SYSTEM_LOGS_FAILED',
  PUSH_ACCOUNT_SYSTEM_LOGS: 'PUSH_ACCOUNT_SYSTEM_LOGS',
  RESET_ACCOUNT_SYSTEM_LOGS: 'RESET_ACCOUNT_SYSTEM_LOGS',

  READ_ACCOUNT_NOTIFICATION: 'READ_ACCOUNT_NOTIFICATION',
  READING_ACCOUNT_NOTIFICATION: 'READING_ACCOUNT_NOTIFICATION',
  READ_ACCOUNT_NOTIFICATION_SUCCESS: 'READ_ACCOUNT_NOTIFICATION_SUCCESS',
  READ_ACCOUNT_NOTIFICATION_FAILED: 'READ_ACCOUNT_NOTIFICATION_FAILED',

  READ_ACCOUNT_SYSTEM_LOGS: 'READ_ACCOUNT_SYSTEM_LOGS',
  READING_ACCOUNT_SYSTEM_LOGS: 'READING_ACCOUNT_SYSTEM_LOGS',
  READ_ACCOUNT_SYSTEM_LOGS_SUCCESS: 'READ_ACCOUNT_SYSTEM_LOGS_SUCCESS',
  READ_ACCOUNT_SYSTEM_LOGS_FAILED: 'READ_ACCOUNT_SYSTEM_LOGS_FAILED',

  FETCH_APPROVAL_REQUESTS: 'FETCH_APPROVAL_REQUESTS',
  LOADING_MORE_APPROVAL_REQUESTS: 'LOADING_MORE_APPROVAL_REQUESTS',
  FETCHING_APPROVAL_REQUESTS: 'FETCHING_APPROVAL_REQUESTS',
  FETCH_APPROVAL_REQUESTS_SUCCESS: 'FETCH_APPROVAL_REQUESTS_SUCCESS',
  FETCH_APPROVAL_REQUESTS_FAILED: 'FETCH_APPROVAL_REQUESTS_FAILED',
  RESET_APPROVAL_REQUESTS: 'RESET_APPROVAL_REQUESTS',

  UPDATE_APPROVAL_REQUEST_STATUS: 'UPDATE_APPROVAL_REQUEST_STATUS',
  UPDATING_APPROVAL_REQUEST_STATUS: 'UPDATING_APPROVAL_REQUEST_STATUS',
  UPDATE_APPROVAL_REQUEST_STATUS_SUCCESS: 'UPDATE_APPROVAL_REQUEST_STATUS_SUCCESS',
  UPDATE_APPROVAL_REQUEST_STATUS_FAILED: 'UPDATE_APPROVAL_REQUEST_STATUS_FAILED',

  FETCH_SUCCESS_RATE: 'FETCH_SUCCESS_RATE',
  FETCHING_SUCCESS_RATE: 'FETCHING_SUCCESS_RATE',
  FETCH_SUCCESS_RATE_SUCCESS: 'FETCH_SUCCESS_RATE_SUCCESS',
  FETCH_SUCCESS_RATE_FAILED: 'FETCH_SUCCESS_RATE_FAILED',

  MARK_AS_READ_ALL_LOG_ACTION: 'MARK_AS_READ_ALL_LOG_ACTION',
  MARK_AS_READ_ALL_NOTIFICATION: 'MARK_AS_READ_ALL_NOTIFICATION',

  SET_NOTIFICATION_DATA: 'SET_NOTIFICATION_DATA',

  fetchPaymentCount: payload => ({
    type: actions.FETCH_PAYMENT_COUNT,
    payload: payload
  }),
  fetchSuccessRate: (payload) => ({
    type: actions.FETCH_SUCCESS_RATE,
    payload
  }),
  getPaymentCount: () => ({
    type: actions.LOAD_DASHBOARD_DATA
  }),
  resetDashboardData: () => ({
    type: actions.RESET_DASHBOARD_DATA
  }),
  getUserSettings: payload => ({
    type: actions.GET_USER_SETTINGS,
    payload
  }),
  isVatAggree: payload => ({
    type: actions.UPDATE_VAT_AGGREE,
    payload
  }),
  resetPchannelCount: () => ({
    type: actions.RESET_FETCHED_PAYMENT_COUNT
  }),
  fetchAccountNotification: (payload) => ({
    type: actions.FETCH_ACCOUNT_NOTIFICATION,
    payload
  }),
  resetAccountNotification: payload => ({
    type: actions.RESET_ACCOUNT_NOTIFICATION,
    payload
  }),
  fetchSystemLogs: (payload) => ({
    type: actions.FETCH_ACCOUNT_SYSTEM_LOGS,
    payload
  }),
  resetSystemLogs: payload => ({
    type: actions.RESET_ACCOUNT_SYSTEM_LOGS,
    payload
  }),
  readAccountNotification: (payload, id) => ({
    type: actions.READ_ACCOUNT_NOTIFICATION,
    payload,
    id
  }),
  readAccountSystemLogs: (payload, id) => ({
    type: actions.READ_ACCOUNT_SYSTEM_LOGS,
    payload,
    id
  }),

  fetchApprovalRequests: (payload) => ({
    type: actions.FETCH_APPROVAL_REQUESTS,
    payload
  }),
  updateApprovalRequest: (payload, id) => ({
    type: actions.UPDATE_APPROVAL_REQUEST_STATUS,
    payload,
    id
  }),
  markAsReadAllLogAction: () => ({
    type: actions.MARK_AS_READ_ALL_LOG_ACTION
  }),
  markAsReadAllNotification: () => ({
    type: actions.MARK_AS_READ_ALL_NOTIFICATION
  })
};
export default actions;
